import apiService, { POST } from '../../apiService'
import { PATH } from './constants'

export const baseController = (configService) => {
	const service = apiService(configService)
	return {
		savePoint: (params) => {
			return service.post({
				url: `${PATH.DEFAULT}/luckywheel/save_point`,
				body: { ...params, flow: 'New', type: 'receive', platform: 'WEB' },
			})
		},
		notiProblemTaxApp: (params) => {
			return service.post({
				url: `${PATH.DEFAULT}/notification/sendNotification`,
				body: { ...params, type: 'FOLLOW' },
			})
		},
		getUrlObject: (params) => {
			return POST({
				url: `https://api-center.finbrokerapp.com/api/v1/file/get-url-object`,
				body: {
					urls: params,
					expiresIn: 60,
					typeResponse: 'LINK',
				},
				headers: {
					'x-api-key': 'fininsurance',
					'Content-Type': 'application/json',
				},
			})
		},
		saveVifOrder: (params) => {
			return POST({
				url: `https://taskbackend-fin-sale.com/api/v2/sales/save-vif-order`,
				body: params,
				headers: {
					'x-api-key': 'fininsurance',
					'Content-Type': 'application/json',
				},
			})
		},
	}
}
